import React, { useContext } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import Constant from "../../Constants";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import { useNavigate } from "react-router-dom";

function GuestPosts({ guestPosts, guestTotal }) {
  const { t } = useContext(LanguageContext);
  const { linkTypeItems } = Constant();
  const { selectedTheme } = useContext(ThemeContext);
  const navigate = useNavigate();

  const navigateToOpenDetails = (uuid) => {
    navigate(`/contracts/${uuid}`);
  };
  return (
    <div
      id="guestsSection"
      className="card mb-5 me-1"
      style={{ minHeight: "177px" }}
    >
      <div className="card-header d-flex justify-content-between pb-1 pt-4 ps-3">
        <h4 className="card-title">
          {t("Guest Post(s)")} {t("Details")}
        </h4>
        <p
          className="responsive-text-affiliation text-secondary"
          style={{ fontWeight: "700" }}
        >
          {t("Sub Total")}: ${guestTotal}
        </p>
      </div>
      <div className="table-responsive datatable-custom">
        <table
          className="table table-thead-bordered table-nowrap card-table"
          style={{ border: "transparent" }}
        >
          <thead className="thead-light">
            <tr>
              <th className="pe-md-2 pe-xl-2 border-unset">#</th>
              <th className="ps-0">{t("WEBSITE")}</th>
              <th className="px-1">{t("PLACEMENT")}</th>
              <th className="px-1">{t("LINK TYPE")}</th>
              <th className="px-1">{t("CONTRACT")}</th>
              <th className="px-1">{t("Price")}</th>
              <th className="table-column-ps-0 px-1"></th>
            </tr>
          </thead>

          <tbody className="align-middle">
            {!!guestPosts?.length ? (
              guestPosts?.map((item, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td className="font-table display-row align-middle justify-content-between pe-xl-2 pt-0 pe-2 pb-0 fw-bold">
                      {index + 1}
                    </td>
                    <td className="ps-0 py-2 ">
                      <div className="d-flex flex-column gap-2">
                        <div>
                          <span className="h4 text-inherit font-table">
                            {item?.post?.offer?.domain?.domain}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="py-2 px-1 font-table">
                      {item?.post?.article ? (
                        <div
                          className="w-auto"
                          style={{ color: "rgba(145, 146, 147, 1)" }}
                        >
                          {t("Article")}
                        </div>
                      ) : (
                        <div>{t("No Article")}</div>
                      )}
                    </td>
                    <td className="py-2 px-1 ">
                      <div>
                        <small className="text-primary font-table">
                          {item?.post?.offer?.links}{" "}
                          {item?.post?.offer?.links && `\u00A0\u2022\u00A0`}{" "}
                          {linkTypeItems[item?.post?.offer?.type]}
                        </small>
                      </div>
                    </td>
                    <td className="py-2 px-1 font-table">
                      <div>
                        <small
                          className="text-orange text-decoration-underline cursor-pointer font-table"
                          onClick={() => navigateToOpenDetails(item?.uuid)}
                        >
                          {item?.code}
                        </small>
                      </div>
                    </td>

                    <td className="py-2 text-dark px-1 font-table">
                      <p style={{ fontWeight: "700", margin: "unset" }}>
                        {" "}
                        ${item?.post?.offer?.price}
                      </p>
                    </td>
                    <td className="table-column-ps-0 kebab-menu py-2 px-1">
                      <div className="dropdowm">
                        <button
                          type="button"
                          className="btn btn-ghost-secondary btn-icon btn-sm rounded-circle"
                          id="teamsDropdown2"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="bi-three-dots-vertical fs-4"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  {index !== guestPosts.length - 1 && (
                    <tr>
                      <td colSpan="100%" style={{ border: "transparent" }}>
                        <div
                          style={{
                            width: "calc(100% - 2px)",
                            height: "2px",
                            backgroundColor:
                              selectedTheme === "dark"
                                ? "rgba(45, 50, 54, 1)"
                                : "rgb(157 157 157)",
                            margin: "0 auto",
                          }}
                        />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="100%">
                  <div
                    className="text-center p-4"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      textAlign: "center",
                    }}
                  >
                    <img
                      className="mb-3"
                      src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                      alt=""
                      style={{ width: "10rem" }}
                      data-hs-theme-appearance="dark"
                    />
                    <img
                      className="mb-3"
                      src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                      alt=""
                      style={{ width: "10rem" }}
                      data-hs-theme-appearance="default"
                    />
                    <p className="mb-0">
                      {!guestPosts ? "Loading data" : "No data to show"}
                    </p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default GuestPosts;
